
import { computed, defineComponent } from 'vue';
import { Colour } from '../../../helpers/colour';
import './arrowLink.scss';

/**
 * A component.
 *
 * Can be used to wrap around a component or more, for example: <code>&lt;Link href="..."&gt;...&lt;/Link&gt;</code>
 *
 * Or as a basic text only link as follows: <code>&lt;Link content="..." href="..." /&gt;</code>
 *
 * @example
 * <code>import ArrowLink from '@manifesto-tech/tpximpact-design-system/components/atoms/link/arrowLink.vue'</code>
 */
export default defineComponent({
  name: 'ArrowLink',

  props: {
    /**
     * The text content of the link
     */
    content: {
      type: String,
      required: true,
    },

    /**
     * The destination of the link
     */
    href: {
      type: String,
      required: true,
    },

    /**
     * Title: descriptive text about the link
     */
    title: {
      type: String,
    },

    /**
     * Target: Link target value
     */
     target: {
      type: String,
    },

    /**
     * Colour: color of the link
     */
    colour: {
      default: Colour.Blue,
      type: String,
      validator: (value: Colour) => {
        return Object.values(Colour).includes(value);
      },
    },
  },

  data() {
    return {
      colourClasses: computed(() => ({
        [`text--${this.colour}`]: !!this.colour,
        [`border--${this.colour}`]: !!this.colour,
        [`fill--${this.colour}`]: !!this.colour,
      })),
    };
  },
});
